import $ from "jquery";

const MobileMenu = (el) => {
    const $el = $(el);
    $el.click(function (e) {
        e.preventDefault();

        console.log($el.data("toggle"));

        $("body").toggleClass("js-state-menu-open");
        $el.toggleClass("js-state-menu-open");

        if ($el.data("toggle") !== undefined) {
            $($el.data("toggle")).toggleClass("js-state-menu-open");
        }
    });

    $(window).resize(function () {
        if ($(window).width() > 1100) {
            $("body").removeClass("js-state-menu-open");
            $el.removeClass("js-state-menu-open");
            if ($el.data("toggle") !== undefined) {
                $($el.data("toggle")).removeClass("js-state-menu-open");
            }
        }
    });
};

export default MobileMenu;
